import { Outlet, useLocation } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import styles from './AppShell.module.css';

export function AppShell(): JSX.Element {
  const { pathname } = useLocation();
  const mainRef = useRef<HTMLElement>(null);
  // The sidebar collapses off-canvas below 900px; this drives the mobile drawer.
  const [navOpen, setNavOpen] = useState(false);

  // On every route change: reset the content scroll to the top of the new
  // page and move focus to <main> for keyboard / screen-reader users — both
  // without the browser's default focus() scroll-into-view jump, so a nav
  // click never scrolls the page. Also close the mobile nav drawer.
  useEffect(() => {
    setNavOpen(false);
    const el = mainRef.current;
    if (!el) return;
    el.scrollTop = 0;
    el.scrollLeft = 0;
    el.focus({ preventScroll: true });
  }, [pathname]);

  return (
    <div className={styles.shell}>
      <Topbar onMenuToggle={() => { setNavOpen((o) => !o); }} navOpen={navOpen} />
      <Sidebar open={navOpen} onClose={() => { setNavOpen(false); }} />
      <main id="main" ref={mainRef} tabIndex={-1} className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
